/**
 * Selection of `Measurement` (Aufmaßprotokoll), shared by the page fragment and the block
 * project-measurement-report-data, so both read the same fields.
 */
export const MEASUREMENT_SELECTION = `
  measurementApprovementNote
  completed {
    type
    value
  }
  roofType
  pitchedRoof {
    conditionState
    bricksPlasteredState
    cardboardPoppetState
    notes
    rafterVisibleState
    rafterWidth
    rafterGap
    rafterNotes
    eavesHeight1
    eavesHeight2
    rafterInsulationState
    rafterInsulationNotes
    lightningProtectionState
    integrateLightningProtectionState
    bricksRemoveableState
    bricksRemoveableNotes
    roofPitchInDegrees
    outerRoofNotes
    bricksConditionState
    brickManufacturer
    brickType
    brick {
      id
      manufacturer
      type
    }
    tinBricksRequiredState
    bricksNotes
    roofSidesAssignedState
    roofSidesMeasurements
    roofSidesShadowsState
    roofSidesNotes
    scaffoldingPossibleState
    scaffoldingPossibleNotes
    rainPipeMaterialType
    rssUsableState
    rssUsableNotes
    roadBlockRequiredState
    overheadLineState
    roofAccessNotes
  }
  ac {
    hakLocationState
    hakAndZsSameRoomState
    hakLockedState
    hakToZsDistance
    fireServiceSwitchPresentState
    hakNotes
    zsLocationState
    newZsRequiredState
    zsSubDistributionRequiredState
    zsSubDistributionRequiredNotes
    netType
    zsNotes
    electricMeterCount
    electricMeterList
    intermediateMeterRequesteddState
    meterCombinationOrCascadeRequestedState
    electricMeterOptionalNotes
    acInstallationLocationState
    mateboxToZsDistance
    breakthroughCountState
    cabelPathDescription
    locationAndCablePathNotes
    equipotentialBusBarPresentState
    earthingPresentState
    earthinghNotes
    internetConnectionPresentState
    lanConnectionPresentState
    internetConnectionNotes
    wallboxRequiredState
    heavyCurrentPresentState
    wallboxWirelessInstallationPossibleState
    wallboxWirelessInstallationPossibleNotes
    wallboxCablePathNotes
    wallboxNotes
  }
  customer {
    customerQuestions
    customerWorking
    customerSignature
  }
  flatRoof {
    buildingHeight
    roofDimension
    flatRoofPitchInDegrees
    flatRoofingMaterialType
    flatRoofingMaterialNotes
    atticPresentState
    atticPresentNotes
    flatRoofNotes
  }
`;
